// extracted by mini-css-extract-plugin
export default {"drink_recipe_card":"DrinkRecipeCard_drink_recipe_card__bLQfJ","header":"DrinkRecipeCard_header__oeacH","body":"DrinkRecipeCard_body__9WXFf","footer":"DrinkRecipeCard_footer__FK9y4"};